import React from 'react';

const HelpItem8 = () => {
  return (
    <>
      <p className='p'>
        When you select the photo wall you will see interesting photos submitted
        by the restaurants.
      </p>
      <p className='p'>
        Clicking the photo will reveal a caption and a link to the restaurant
        detail page which includes menus, gymMembers and entertainment items.
      </p>
    </>
  );
};

export default HelpItem8;
